import {helper, http, api} from '../common/common';

class LoadRegion {
    constructor(onLoad, onError, getAccessCode, lite) {
        this._onLoad = onLoad;
        this._onError = onError;
        this._getAccessCode = getAccessCode;
        this._lite = lite ? true : false;
        this._regionListTimestamp = 0;
        this._regionList = [];
        this._cancelToken = http.CancelToken.source();
    }

    unmount = () => {
        if (this._cancelToken) {
            this._cancelToken.cancel();
        }
    }

    query = (defaultValueHint) => {
        this._requestMapping(defaultValueHint);
    }

    _sortList = (left, right) => {
        return left.properties.name.localeCompare(
            right.properties.name, 'en', {sensitivity: 'base'});
    }

    _processError = (error) => {
        if (this._onError) {
            this._onError(error);
        }
    }

    _requestMapping = async (defaultValueHint) => {
        try {
            const response = await http.get(api.permission() + '/mapping', {
                params: {
                    'access_code': this._getAccessCode(),
                },
                cancelToken: this._cancelToken.token,
            });

            this._requestRegions(response.data.key, defaultValueHint);
        } catch (error) {
            if (http.isCancel(error)) {
                return;
            }

            const e = helper.sanitizeError(error, 'Area Error', 'Unable to load area');
            this._processError(e);
        }
    }

    _requestRegions = async (regionMap, defaultValueHint) => {
        try {
            this._regionList = [];

            if (regionMap.length === 0) {
                this._regionListTimestamp = Date.now();

                if (this._onLoad) {
                    this._onLoad(this._regionListTimestamp, this._regionList, 0);
                }

                return;
            }

            const response = await Promise.all(regionMap.map(this._requestSingleZone));

            for (const r of response) {
                this._regionList = this._regionList.concat(r);
            }

            this._regionList.sort(this._sortList);

            this._regionListTimestamp = Date.now();

            var defaultIndex = 0;

            for (var i=0; i<this._regionList.length; ++i) {
                const compareResult = this._regionList[i].properties.key.localeCompare(
                    defaultValueHint, 'en', {sensitivity: 'base'});

                if (compareResult === 0) {
                    defaultIndex = i;
                    break;
                }
            }

            if (this._onLoad) {
                this._onLoad(this._regionListTimestamp, this._regionList, defaultIndex);
            }
        } catch (error) {
            if (http.isCancel(error)) {
                return;
            }

            const e = helper.sanitizeError(error, 'Region Error', 'Unable to load region');
            this._processError(e);
        }
    }

    _requestSingleZone = async (organization) => {
        try {
            const endpoint = this._lite ? '/boundary-lite' : '/boundary';

            const response = await http.get(api.map() + endpoint, {
                params: {
                    'access_code': this._getAccessCode(),
                    'organization': organization,
                    'region': 'data',
                },
                cancelToken: this._cancelToken.token,
            });

            const result = [];

            if (Object.entries(response.data.content).length) {
                for (const f of response.data.content.features) {
                    f.properties.organization = organization;
                    result.push(f);
                }
            }

            return result;
        } catch (error) {
            throw error;
        }
    }
}

export default LoadRegion;
